import { environmentConfigs } from '@team-milva/lab-constants/environments'

export const LAB_CLOUD_URL = {
  EMULATOR: 'http://localhost:5001/lab-services-dev/europe-west3',
  DEV: environmentConfigs['lab-services-dev'].cloudFunctionsHost,
  STAGE: environmentConfigs['lab-services-stage'].cloudFunctionsHost,
  PROD: environmentConfigs['lab-services-prod'].cloudFunctionsHost,
} as const

// Standard padding for a page's scrolling content area — keeps every view's
// gutters identical. pb-32 (not pb-10) so the last section/button on a long
// page isn't cramped against the scroll container's bottom edge.
export const PAGE_CONTENT_PADDING_CLASS = 'px-10 pt-6 pb-32'
